import _ from 'lodash';
import REST from '../rest';

const ENDPOINT = 'api/v1/reports';

export const load = (props) => REST.get(
  ENDPOINT,
  _.get(props, 'id'),
  { ...props, include: 'category,company' },
);
export const create = (data) => REST.post(ENDPOINT, data);
export const update = (id, data) => REST.patch(ENDPOINT, id, data);
export const archive = (id, data) => REST.patchAction(ENDPOINT, id, 'archive', data);
export const hide = (id, data) => REST.patchAction(ENDPOINT, id, 'hide', data);
export const updateAccess = (data) => REST.patchAction(ENDPOINT, null, 'acl', data);
export const remove = (id) => REST.delete(ENDPOINT, id);
